module.exports = __webpack_public_path__ + "static/media/phone.6f68c165.svg";